import { Layout } from 'antd';
import styled from 'styled-components';
import Btn from '@/assets/game-chess/Button2.png';

export const Wrapper = styled(Layout)`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  background: #111111;
  min-height: 100svh;
  overflow-x: hidden;
  .button-secondary {
    background: url(${Btn});
    background-size: 100% 100%;
    width: 520px;
    height: 100px;
  }
  .play-btn {
    background: #d39659 !important;
    box-shadow: 0px -24px 64px 0px #ffedb8 inset;
    border-radius: 40px;
    border: 2px solid #53f388;
    width: 160px;
    height: 52px;
  }
  .withdraw-btn {
    background: linear-gradient(180deg, #3ebf37 0%, #9ef3a1 100%) !important;
    border: 2px solid #53f388;
    width: 280px;
    height: 96px;
  }
  .deposit-btn {
    border: 2px solid #474747;
    background: #1f1b1a;
    width: 280px;
    height: 96px;
  }
`;
